module.exports = require("./qu-EC.d.ts");